import { colors } from "components/Theme/WebTheme";
import { FONT_FAMILY } from "../../common/sharedFunctions"
const TableStyle = () => {
    return {
        editable: {
            backgroundColor: '#f8fafc',
            fontSize: "0.82em",
            fontWeight: 700,
            fontFamily: FONT_FAMILY 
          },
          pageSize: 15,
          pageSizeOptions: [15, 30, 60],
          headerStyle: {
            color: '#172033',
            position: "sticky",
            top: "0px",
            backgroundColor: '#f8fafc',
            textAlign: "left",
            fontSize: "0.78em",
            fontWeight: 900,
            borderBottom: `1px solid ${colors.TABLE_BORDER}`,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            fontFamily: FONT_FAMILY 
          },
          cellStyle: {
            borderBottom: `1px solid ${colors.TABLE_BORDER}`,
            borderTop: 0,
            borderLeft: 0,
            borderRight: 0,
            textAlign: "left",
            fontSize: "0.86em",
            color: '#344054',
            whiteSpace: 'nowrap'
          },
          actionsCellStyle: {
            backgroundColor: 'transparent',
          },
          actionsColumnIndex: -1,
        }
};

export default TableStyle;
